import { Tooltip, Button } from "antd";
import { useTranslation } from "react-i18next";
import { useQueryClient } from "react-query";
import { useAppSelector } from "store/hook";
import { ReloadOutlined } from "@ant-design/icons";

const Refresh = ({ queriesArray, extraFunc }: { queriesArray: string[]; extraFunc?: Function }) => {
  const { t } = useTranslation();
  const { stateCid } = useAppSelector((state) => state.global);

  const queryClient = useQueryClient();

  return (
    <Tooltip title={t("ISMS.Refresh")}>
      <Button
        icon={<ReloadOutlined />}
        onClick={() => {
          if (extraFunc) {
            extraFunc();
          }

          return queriesArray.forEach((query) => queryClient.invalidateQueries([query, stateCid]));
        }}
      ></Button>
    </Tooltip>
  );
};

export default Refresh;
